import React, { useState, useRef, useEffect } from "react";

import { Box, Button, FormControl, FormControlLabel, Input, MenuItem, RadioGroup, Radio, Select, Tooltip } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from "@mui/material";

import kutil, { type PageInfo } from "@modules/kutil";
import commonCode, { type Code } from "@modules/common_code";
import valueFormatter from "@modules/value_formatter";

import searchIcon from "@user/assets/images/common/search.svg";

interface State {
}

const defState: State = {
};

interface Info {
  logSystemErrorNo: string,
  errorType: string,
  errorDate: string,
  errorCode: string,
  errorContent: string
}

const defInfo: Info = {
  logSystemErrorNo: "",
  errorType: "",
  errorDate: "",
  errorCode: "",
  errorContent: ""
};

function PopupLogDetail(props: any) {
  const [state, setState] = useState<State>(kutil.deepCopy(defState));
  const [info, setInfo] = useState<Info>(kutil.deepCopy(defInfo));

  useEffect(() => {
    init();
  }, []);

  const isInit = useRef(false);
  async function init() {
    try {
      if (isInit.current == false) {
        isInit.current = await initData();
      }
      if (isInit.current) {
        await initParams();
        await searchInfo();
      }
    } finally {
      kutil.setLoadingStatus(false);
    }
  }

  async function initData() {
    return true;
  }

  async function initParams() {
    const info = props.data.info;
    setInfo(info);
  }

  async function searchInfo() {
  }

  async function closePopup() {
    props.onClose();
  }

  return (
    <>
      {/* 팝업 */}
      <Dialog
        sx={{ "& .MuiDialog-container": { "& .MuiPaper-root": { width: "100%", maxWidth: "1300px", }, }, }}
        aria-labelledby="customized-dialog-title"
        open={props.isShow}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          시스템 오류 로그 조회
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={closePopup}
          sx={(theme) => ({
            position: "absolute",
            right: 36,
            top: 24,
            color: theme.palette.grey[500],
          })}
        >
        </IconButton>
        <DialogContent>
          {/* 팝업 내용 */}
          <div className="popup-contents">
            {/* 오류 정보 */}
            <div className="table-wrap">
              <table>
                <colgroup>
                  <col style={{ width: "12%" }} />
                  <col style={{ width: "38%" }} />
                  <col style={{ width: "12%" }} />
                  <col style={{ width: "38%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">오류구분</th>
                    <td>
                      { commonCode.getCodeValue("errorType", info.errorType) }
                    </td>
                    <th scope="row">오류일자</th>
                    <td>
                      { kutil.date2string(info.errorDate, "yyyy-MM-dd HH:mm:ss") }
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">오류코드</th>
                    <td colSpan={3}>
                      { info.errorCode }
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">오류메시지</th>
                    <td colSpan={3}>
                      <pre>{ info.errorContent }</pre>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/*// 오류 정보 */}
          </div>
          {/*// 팝업 내용 */}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" autoFocus onClick={closePopup}>
            닫기
          </Button>
        </DialogActions>
      </Dialog>
      {/*// 팝업 */}
    </>
  );
}

export default React.memo(PopupLogDetail);
